import type { HTMLAttributes } from 'react';
import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '@/lib/cn';

const badge = cva(
  'inline-flex items-center gap-1.5 rounded-pill border px-2.5 py-0.5 text-xs font-semibold',
  {
    variants: {
      tone: {
        neutral: 'border-hairline-strong bg-surface-sunken text-ink-soft',
        accent: 'border-transparent bg-accent text-on-accent',
        positive: 'border-transparent bg-positive/15 text-positive',
        warning: 'border-transparent bg-warning/20 text-warning',
        critical: 'border-transparent bg-critical/15 text-critical',
        citron: 'border-transparent bg-flavor-citron-soft text-flavor-citron-ink',
        peach: 'border-transparent bg-flavor-peach-soft text-flavor-peach-ink',
        berry: 'border-transparent bg-flavor-berry-soft text-flavor-berry-ink',
        grape: 'border-transparent bg-flavor-grape-soft text-flavor-grape-ink',
        lychee: 'border-transparent bg-flavor-lychee-soft text-flavor-lychee-ink',
        melon: 'border-transparent bg-flavor-melon-soft text-flavor-melon-ink',
      },
    },
    defaultVariants: { tone: 'neutral' },
  },
);

export interface BadgeProps extends HTMLAttributes<HTMLSpanElement>, VariantProps<typeof badge> {}

export function Badge({ className, tone, ...props }: BadgeProps) {
  return <span className={cn(badge({ tone }), className)} {...props} />;
}
